import { TRUST_PILLS } from "../../data/home";

export default function Hero() {
  return (
    <section id="top" className="bg-ivory min-h-[92vh] grid grid-cols-1 lg:grid-cols-2 overflow-hidden relative">
      {/* Ghost watermark */}
      <div
        className="absolute bottom-0 left-0 font-syne font-extrabold leading-none pointer-events-none select-none z-0 whitespace-nowrap"
        style={{ fontSize: 'clamp(120px,16vw,220px)', color: 'rgba(107,53,168,0.05)', letterSpacing: '-0.04em' }}
        aria-hidden="true"
      >OLÓYE</div>

      {/* Left — Copy */}
      <div className="relative z-10 flex flex-col justify-center px-8 py-20 lg:px-16 lg:py-0">
        {/* Eyebrow */}
        <p className="font-syne text-[10px] font-semibold tracking-[0.2em] uppercase text-gold flex items-center gap-2 mb-8">
          <span className="w-7 h-px bg-gold" />
          NYC & New Jersey · Established 2025
        </p>

        <h1
          className="font-syne font-extrabold leading-[1.0] tracking-tight text-ink"
          style={{ fontSize: 'clamp(3rem,5.5vw,5.2rem)' }}
        >
          We Turn
          <br />
          <span style={{ color: 'transparent', WebkitTextStroke: '2px #6B35A8' }}>Any Space</span>
          <br />
          <span className="text-gold font-extrabold">Into Something</span>
          <br />
          <em className="font-serif italic font-light text-ink-35 block mt-2" style={{ fontSize: 'clamp(1.4rem,2.5vw,2rem)' }}>
            unforgettable.
          </em>
        </h1>

        <p className="text-[14px] text-ink-55 font-light leading-[1.8] max-w-[380px] mt-7">
          Balloon installations, custom backdrops, large-format printing, and full event environments — for private celebrations, corporate activations, and government programs.
        </p>

        <div className="flex items-center gap-4 mt-10">
          <a
            href="#contact"
            className="font-syne text-[10.5px] font-bold tracking-[0.18em] uppercase text-white bg-violet px-8 py-3.5 rounded-sm hover:bg-violet-deep hover:-translate-y-0.5 transition-all"
          >
            Book Your Event
          </a>
          <a
            href="#book"
            className="font-syne text-[10.5px] font-semibold tracking-[0.16em] uppercase text-ink-55 border border-ink-20 px-7 py-3.5 rounded-sm hover:border-violet hover:text-violet transition-all"
          >
            Government & Corporate →
          </a>
        </div>

        <div className="flex flex-wrap gap-2 mt-8">
          {TRUST_PILLS.map((pill) => (
            <span
              key={pill}
              className="font-syne text-[9px] font-semibold tracking-[0.14em] uppercase text-ink-35 border border-ink-10 px-3 py-1.5 rounded-sm"
            >
              {pill}
            </span>
          ))}
        </div>
      </div>

      {/* Right — Photo Mosaic */}
      <div className="hidden lg:grid grid-cols-2 grid-rows-2 gap-0.5 bg-ivory-2 relative">
        {/* Top — full width */}
        <div className="col-span-2 relative overflow-hidden bg-violet-deep">
          <img
            src="/wonderland-themed.JPG"
            alt="Wonderland themed balloon installation"
            className="absolute inset-0 w-full h-full object-cover"
          />
        </div>
        {/* Bottom left */}
        <div className="relative overflow-hidden bg-violet-deep">
          <img
            src="/grinch-setup.JPG"
            alt="Grinch themed event setup"
            className="absolute inset-0 w-full h-full object-cover"
          />
        </div>
        {/* Bottom right */}
        <div className="relative overflow-hidden bg-violet-deep">
          <img
            src="/organic-arch.PNG"
            alt="Custom organic balloon arch"
            className="absolute inset-0 w-full h-full object-cover"
          />
        </div>

        {/* Floating stat card */}
        <div className="absolute bottom-6 left-6 bg-ivory/92 backdrop-blur-md border border-violet/25 rounded-lg shadow-xl shadow-ink/10 p-4 z-10">
          <p className="font-syne text-[10px] font-semibold tracking-[0.18em] uppercase text-gold mb-1">
            Events Delivered
          </p>
          <p className="font-syne font-extrabold text-ink tracking-tight text-4xl leading-none">100+</p>
          <p className="text-[11px] text-ink-35 mt-1">NYC & New Jersey</p>
        </div>
      </div>
    </section>
  );
}
